exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_permissions_FAOSM_EnH8mB3CWXs1YDZ {\n  width: 100%;\n  margin-top: 20px;\n}", ""]);

// Exports
exports.locals = {
	"IA_permissions": "IA_permissions_FAOSM_EnH8mB3CWXs1YDZ"
};